<script>
import { generateVisitorId, setVisitorIdCookie, getVisitorIdCookie } from '../visitorIdUtils';

export default {
  props: ['searchEventData'],
  data() {
    return {
      visitorId: null,
    };
  },

  created() {
    const existingVisitorId = getVisitorIdCookie();
    if (!existingVisitorId) {
      const visitorId = generateVisitorId();
      setVisitorIdCookie(visitorId, 365);
    }
    this.visitorId = existingVisitorId;
  },
  watch: {
    searchEventData: {
      handler(newSearchEventData) {
        if (!newSearchEventData || !newSearchEventData.results || !Array.isArray(newSearchEventData.results.results)) {
          return;
        }

        const {
          params: {
            filter = '',
            orderBy = '',
            page = '',
            pageSize = '',
            query = '',
            path = '',
          } = {},
          results: {
            attributionToken = null,
            results: searchResults,
          },
        } = newSearchEventData;

        const offset = (parseInt(page) || 0) * pageSize;

        window.dataLayer.push({
          event: 'search',
          cloud_retail: {
            eventType: 'search',
            visitorId: this.visitorId,
            attributionToken,
            searchQuery: query,
            filter: decodeURIComponent(filter),
            orderBy,
            offset,
            //eventTime: new Date().toISOString(),
            productDetails: searchResults.map(result => ({ product: { id: result.id } })),
            // pageCategories: path,
            userInfo: {
              userId: gacustomerID,
              userAgent: navigator.userAgent,
              directUserRequest: true,
            },
            uri: window.location.href,
            referrerUri: document.referrer,
            pageViewId: window.location.href,
          }
        });
      },
      immediate: true,
    },
  },
};
</script>
